import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { connect as connectStaticText } from '../../StaticText/connect'
import { H1, H2, HEADING_TYPES } from '../../Heading/index'
import Button, { TYPES } from '../../Button/index'
import Link from '../../Link/index'
import GaiaLogo, { TYPE_WHITE } from '../../GaiaLogo/index'
import { URL_LOGOUT, URL_PLAN_SELECTION_PLANS } from '../../../services/url/constants'
import { getUserName } from '../../../services/user/index'

const ModalCartAbandon = ({
  user,
  staticText,
}) => {
  const userName = getUserName(user.get('data'))

  return (
    <div className="modal-cart-abandon">
      <div className="modal-cart-abandon__wrapper">
        <header className="modal-cart-abandon__header">
          <GaiaLogo
            type={TYPE_WHITE}
            className={['modal-cart-abandon__gaia-logo']}
            isHref={false}
          />
        </header>
        <div className="modal-cart-abandon__content">
          <H1
            as={HEADING_TYPES.H3}
            className="modal-cart-abandon__title"
            inverted
          >
            {`${staticText.getIn(['data', 'welcomeBack'])}, ${userName}!`}
          </H1>
          <H2
            as={HEADING_TYPES.H1}
            className="modal-cart-abandon__subtitle"
            inverted
          >
            {staticText.getIn(['data', 'oneStepAway'])}
          </H2>
          <Button
            className="modal-cart-abandon__button"
            type={TYPES.PRIMARY}
            url={URL_PLAN_SELECTION_PLANS}
            scrollToTop
          >
            {staticText.getIn(['data', 'finishSignUp'])}
          </Button>
          <div className="modal-cart-abandon__bottom">
            <Link
              className="modal-cart-abandon__sign-out"
              to={URL_LOGOUT}
              scrollToTop
            >
              {staticText.getIn(['data', 'signOut'])}
            </Link>
          </div>
        </div>
      </div>
      <div className="modal-cart-abandon__background" />
    </div>
  )
}

ModalCartAbandon.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectStaticText({ storeKey: 'modalCartAbandon' }),
  connectRedux(
    (state) => ({
      user: state.user,
    }),
  ),
)(ModalCartAbandon)
